// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"discussionCtaButton_ctaButton__h1dS_"};